import axios from 'axios';

let prefix = "/package"

const PackageTranslationApi = {

	// Get all translations for a package
	getPackageTranslations(packageId) {
		return axios.get(`${prefix}/${packageId}/translations`)
	},

	// Get a specific translation by locale
	getPackageTranslationByLocale(packageId, locale) {
		return axios.get(`${prefix}/${packageId}/translations/${locale}`)
	},

	// Create or update a translation
	savePackageTranslation(packageId, payload) {
		return axios.post(`${prefix}/${packageId}/translations`, payload)
	},

	// Delete a translation
	deletePackageTranslation(packageId, locale) {
		return axios.delete(`${prefix}/${packageId}/translations/${locale}`)
	},

}

export default PackageTranslationApi;
